import React from "react";

import { FieldOption } from "components/FieldSelect/FieldSelect";
import ModalFieldSelect from "components/ModalFieldSelect";
import { getBooleanOptions } from "services/getBooleanOptions";

type Props = {
	title: string;
	isUnlocked: boolean;
	onOK: (arg: FieldOption[]) => void;
	initialValue: boolean;
};

function ModalFieldBoolean({ title, isUnlocked, onOK, initialValue }: Props) {
	return (
		<ModalFieldSelect
			isUnlocked={isUnlocked}
			title={title}
			requireSelection
			onOK={onOK}
			options={getBooleanOptions(initialValue)}
			allowMultipleSelections={false}
		/>
	);
}

export default ModalFieldBoolean;
